module.exports = __webpack_public_path__ + "static/media/modalLabel--author.b8d013b4.svg";